import React, { Suspense } from 'react';
import { Loader2, Users } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Lazy load components
const AmbulanceInstantBooking = React.lazy(() => import('../../pages/AmbulanceInstantBooking'));
const FleetDashboardStatsNoHospitals = React.lazy(() => import('./FleetDashboardStatsNoHospitals'));

const FleetBooking = () => {
  const { user } = useAuth();

  const handleBookingChange = (data) => {
    console.log('Fleet booking data:', data);
  };

  return (
    <div className="space-y-6">
      {/* Fleet Dashboard Stats */}
      <Suspense fallback={
        <div className="flex items-center justify-center py-4">
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          <span className="text-gray-600 text-sm">Loading dashboard...</span>
        </div>
      }>
        <FleetDashboardStatsNoHospitals />
      </Suspense>

      {/* Fleet Operator Info */}
      {user?.operator && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-center">
            <Users className="w-5 h-5 text-blue-600 mr-2" />
            <div>
              <h3 className="text-sm font-medium text-blue-900">Fleet Operator</h3>
              <p className="text-sm text-blue-700">
                {user.operator.name || user.operator.operator_name || 'Your Fleet'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Ambulance Instant Booking Form */}
      <div>
        <Suspense fallback={
          <div className="flex items-center justify-center py-6 sm:py-8">
            <Loader2 className="w-5 h-5 sm:w-6 sm:h-6 animate-spin mr-2" />
            <span className="text-gray-600 text-sm sm:text-base">Loading booking form...</span>
          </div>
        }>
          <AmbulanceInstantBooking
            layout="default"
            onBookingChange={handleBookingChange}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default FleetBooking;
